let apidaeQuickSearch = {
    props: {
        title: String,
        nbPrestas: Number,
        type: String,
        params: Object,
        groupesFiltres: Array,
        lang: String,
        pmin: Number,
        pmax: Number,
        njmin: Number,
        njmax: Number,
        showFiltreDate: Number,
        showFiltreAge: Number,
        showFiltrePrice: Number,
        showFiltreCapacity: Number,
        showFiltreNombreChambres: Number,
        showFiltreNombreJours: Number,
        showFiltreNombreNuits: Number,
        showFiltreDistance: Number,
        showFiltreDuration: Number,
        showFiltreElevation: Number
    },
    computed: {
        currentDate: function() {
            return new Date().toJSON().slice(0,10);
        }
    },
    components: {
        groupFilters,
        filtreDate,
        filtrePrice,
        filtreNombreJours
    },
    directives: {
        clickaway
    },
    data() {
        return {
            isDropdownActive: false,
        }
    },
    methods: {
        save() {
            this.$root.submitfilters(event)
        },
        datevent() {
            this.$root.callfilters(event)
        },
        pricevent() {
            this.$root.callfilters(event)
            this.isDropdownActive = false
        },
        away() {
            this.isDropdownActive = false;
        }
    },
    template: `
    <div class="Profiles">
        <form @submit.prevent="save">
            <div class="Profiles__title">{{ title }}</div>
            <div class="profile-vertical">
                <template v-if="!groupeFiltres.hide" v-for="(groupeFiltres, index) in groupesFiltres">
                    <group-filters :groupe-filtres="groupeFiltres"></group-filters>
                </template>
                <filtre-price v-if="showFiltrePrice" :pmin="pmin" :pmax="pmax" />
                <filtre-nombre-jours v-if="showFiltreNombreJours" :njmin="njmin" :njmax="njmax" />
                <filtre-date v-if="showFiltreDate" :params="params" />
                <div class="text-right">
                    <button class="button large" type="submit">Voir les {{ nbPrestas }} résultats</button>
                </div>
            </div>
        </form>
    </div>`
} 

//https://embed.plnkr.co/plunk/8XdCd2
if (document.querySelector('.prestaQuickSearch')) {
    document.querySelectorAll('.prestaQuickSearch').forEach(i => {
        let id = i.getAttribute('id');
        let uri = i.dataset.url;
        let title = i.dataset.title;
        let type = i.dataset.type;
        let lang = i.dataset.lang;
        let showFiltre = parseInt(i.dataset.showfiltre);
        let showFiltreDate = parseInt(i.dataset.showfiltredate);
        let showFiltreAge= parseInt(i.dataset.showfiltreage);
        let showFiltrePrice = parseInt(i.dataset.showfiltreprice);
        let showFiltreCapacity = parseInt(i.dataset.showfiltrecapacity);
        let showFiltreNombreChambres = parseInt(i.dataset.showfiltrenombrechambres);
        let showFiltreNombreJours = parseInt(i.dataset.showfiltrenombrejours);
        let showFiltreNombreNuits = parseInt(i.dataset.showfiltrenombrenuits);
        let showFiltreDistance = parseInt(i.dataset.showfiltredistance);
        let showFiltreDuration = parseInt(i.dataset.showfiltreduration);
        let showFiltreElevation = parseInt(i.dataset.showfiltreelevation);
        new Vue({
            // delimiters: ['%%', '%%'],
            el: '#' + id,
            components: { apidaeQuickSearch },
            data: function () {
                return {
                    loading: true,
                    title: title,
                    nbPrestas: 0,
                    type: type,
                    params: {},
                    groupesFiltres: [],
                    lang: lang,
                    pmin: 0,
                    pmax: 10000,
                    njmin: 0,
                    njmax: 8,
                    showFiltre: showFiltre,
                    showFiltreDate: showFiltreDate,
                    showFiltreAge: showFiltreAge,
                    showFiltrePrice: showFiltrePrice,
                    showFiltreCapacity: showFiltreCapacity,
                    showFiltreNombreChambres: showFiltreNombreChambres,
                    showFiltreNombreJours: showFiltreNombreJours,
                    showFiltreNombreNuits: showFiltreNombreNuits,
                    showFiltreDistance: showFiltreDistance,
                    showFiltreDuration: showFiltreDuration,
                    showFiltreElevation: showFiltreElevation,
                }
            },
            mounted: function() {
                fetch(apidae.site_url + uri + '/json')
                    .then(stream => stream.json())
                    .then(data => {
                        this.params = data.params;
                        this.nbPrestas = data.items.length;
                        this.groupesFiltres = data.filtres;

                        this.loading = false;
                    })
                    .catch(error => console.error(error))
            },
            methods: {
                callfilters: function(event) {
                    // console.log(event);
                    loadData = true;
                    let apiUrl = apidae.site_url + uri + '/json';
                    let query = '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=';

                    if (event.target.classList.contains('pricevent')) {
                        this.pmin = Number(event.target.getAttribute('data-pmin'))
                        this.pmax = Number(event.target.getAttribute('data-pmax'))
                    }
                    query += '&pmin=' + this.pmin + '&pmax=' + this.pmax;

                    if (event.target.classList.contains('nombrejoursevent')) {
                        this.njmin = Number(event.target.getAttribute('data-njmin'))
                        this.njmax = Number(event.target.getAttribute('data-njmax'))
                    }
                    query += '&njmin=' + this.njmin + '&njmax=' + this.njmax;

                    if (showFiltreDate) {
                        query += '&rbl=calendar&dd=' + this.params.dateDebut + '&df=' + this.params.dateFin;
                    }

                    // console.log(this.groupesFiltres);
                    let cgroupesFiltres = this.groupesFiltres;
                    cgroupesFiltres.forEach(cgroupefiltres => {
                        let cfiltres = cgroupefiltres.listeFiltre;
                        cfiltres.forEach(cfiltre => {
                            // console.log(cfiltre.selected);
                            if (cfiltre.selected) {
                                // console.log(cfiltre.idFiltre);
                                query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                            }
                        });
                    });
                    // console.log(cgroupesFiltres);
                    // console.log(query);

                    fetch(apiUrl + query)
                        .then(stream => stream.json())
                        .then(data => {
                            this.nbPrestas = data.items.length;
                            this.groupesFiltres = data.filtres;
                        })
                        .catch(error => console.error(error))
                },
                submitfilters: function(event) {
                    let query =  uri + '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=&njmin=' + this.njmin + '&njmax=' + this.njmax + '&pmin=' + this.pmin + '&pmax=' + this.pmax;
                    let cgroupesFiltres = this.groupesFiltres;
                    cgroupesFiltres.forEach(cgroupefiltres => {
                        let cfiltres = cgroupefiltres.listeFiltre;
                        cfiltres.forEach(cfiltre => {
                            // console.log(cfiltre.selected);
                            if (cfiltre.selected) {
                                console.log(cfiltre.idFiltre);
                                query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                            }
                        });
                    });
                    // console.log(apidae.site_url + uri);
                    window.location = apidae.site_url + query;
                }
            }
        });
    })
}
